export const API_URL = import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? "http://localhost:5000" : "https://api.dyen.org");
export const WEBSITE_URL =
  import.meta.env.VITE_WEBSITE_FRONTEND_URL ||
  (import.meta.env.DEV ? "http://localhost:3000" : "https://dyen.org");
